module.exports = __webpack_public_path__ + "img/more_func.54631cdb.png";